module.exports = __webpack_public_path__ + "img/index.efa3e97e.png";